import { Component, OnInit } from '@angular/core';
import { SubjectService } from '@app/services/subject.service';

@Component({
  selector: 'app-my-clients',
  templateUrl: './my-clients.component.html',
  styleUrls: ['./my-clients.component.scss']
})
export class MyClientsComponent implements OnInit {

  constructor(
    public subject: SubjectService
  ) { }

  ngOnInit() {
    this.subject.headerCollapse(true);
  }

  ngOnDestroy() {
    this.subject.headerCollapse(false);
  }
}